import Vue from 'vue';

import {IActionsSignature, ISystemStore} from "@/models/StoreModels";
import {DISPLAY_MODE} from "@/constants/system";
import {pwaInstallerService} from "@/services/services";
import {IUpdateValueParameters} from "@/services/PWAInstallerService";

const initialState = (): ISystemStore => {
  return {
    canInstall: false,
    isInstalled: false,
    displayMode: DISPLAY_MODE.STANDALONE,
  };
};


const getters = {
  getCanInstall(state: ISystemStore): boolean {
    return state.canInstall;
  },

  getIsInstalled(state: ISystemStore): boolean  {
    return state.isInstalled;
  },

  getDisplayMode(state: ISystemStore): DISPLAY_MODE {
    return state.displayMode;
  },

  isRunningInStandaloneMode(state: ISystemStore): boolean {
    return state.displayMode !== DISPLAY_MODE.BROWSER_TAB;
  },

  showInstallButton(state: ISystemStore, myGetters: any): boolean {
    return myGetters.getCanInstall && !myGetters.getIsInstalled && !myGetters.isRunningInStandaloneMode;
  },

};


const actions = {
  init({commit}: IActionsSignature<ISystemStore>) {
    commit('reset');

    const updateValues = ({canInstall, isInstalled, displayMode}: IUpdateValueParameters): void => {
      commit('setCanInstall', canInstall);
      commit('setIsInstalled', isInstalled);
      commit('setDisplayMode', displayMode);
    };

    pwaInstallerService.setUpdateValuesCallback(updateValues);
  },

  reset({commit}: IActionsSignature<ISystemStore>) {
    commit('reset');
  },

  setCanInstall: ({commit}: IActionsSignature<ISystemStore>, canInstall: boolean) => {
    commit('setCanInstall', canInstall);
  },

  setIsInstalled: ({commit}: IActionsSignature<ISystemStore>, isInstalled: boolean) => {
    commit('setIsInstalled', isInstalled);
  },

  setDisplayMode: ({commit}: IActionsSignature<ISystemStore>, displayMode: boolean) => {
    commit('setDisplayMode', displayMode);
  },



};


const mutations = {

  reset(state: ISystemStore) {
    state = Object.assign(state, initialState());
  },

  setCanInstall(state: ISystemStore, canInstall: boolean) {
    Vue.set(state, 'canInstall', canInstall);
  },

  setIsInstalled(state: ISystemStore, isInstalled: boolean) {
    Vue.set(state, 'isInstalled', isInstalled);
  },

  setDisplayMode(state: ISystemStore, displayMode: DISPLAY_MODE) {
    Vue.set(state, 'displayMode', displayMode);
  },

};

export default {
  namespaced: true,
  state: initialState,
  getters,
  actions,
  mutations,
};
